import {FC} from "react";
import {
   ApolloClient,
   ApolloLink,
   ApolloProvider,
   createHttpLink,
   from,
   InMemoryCache,
   NextLink,
   Operation
} from "@apollo/client";
import {useRecoilValue} from "recoil";
import {onError} from "@apollo/client/link/error";
import {PubSub} from "../utility/PubSub";
import {getMainDefinition} from "@apollo/client/utilities";
import {OperationDefinitionNode} from "graphql";
import {setContext} from "@apollo/client/link/context";
import {LoginContext} from "../pages/LoginContext";
import {GraphqlServerUrl} from "../Settings";

const cache = new InMemoryCache({});

export const GraphQLProvider: FC<any> = ({children}) => {
   const loginContext = useRecoilValue(LoginContext);

   const errorLink = onError(({graphQLErrors, networkError}) => {
      if (graphQLErrors) {
         if (graphQLErrors.find(error => {
            return error.message && error.message.startsWith("Not Authorised");
         })) {
            PubSub.emit('logout', graphQLErrors);
         }
      }
   });

   const cleanTypenameLink = new ApolloLink((operation: Operation, forward: NextLink) => {
      const omitTypename = (key: any, value: any) =>
         key === "__typename" ? undefined : value;

      const def = getMainDefinition(operation.query);
      if (def && ((def as OperationDefinitionNode).operation === "mutation")) {
         operation.variables = JSON.parse(JSON.stringify(operation.variables), omitTypename);
      }
      return forward ? forward(operation) : null;
   });

   let context = setContext((request) => ({
      headers: {authorization: loginContext.token ? loginContext.token : undefined}
   }));

   let oihGraphQL = from([
      cleanTypenameLink,
      errorLink,
      context,
      createHttpLink({uri: GraphqlServerUrl})
   ]);
   let apolloClient = new ApolloClient({
      cache,
      link: oihGraphQL,
      defaultOptions: {
         query: {
            errorPolicy: 'all'
         },
         mutate: {
            errorPolicy: 'all'
         },
         watchQuery: {
            errorPolicy: 'all'
         }
      }
   });
   return <ApolloProvider client={apolloClient}>
      {children}
   </ApolloProvider>
}
